import {useDispatch, useSelector} from "react-redux";
import {useLocation, useRouteMatch} from "react-router";

import {parseSearch} from "@pg-mono/request";

import {clientRpRequestMeta} from "../../../../client/client_rp_request_meta";
import {IRPStore} from "../../../app/rp_reducer";
import {fetchOfferList} from "../actions/fetch_offer_list";
import {OfferListSubType} from "../types/OfferListSubType";

export const useFetchOfferList = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const match = useRouteMatch<{friendlySlug?: string; offerListSubType?: OfferListSubType}>();
    const latestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);

    return async () => {
        // Do not fetch offers for `CREDIT_TWO_PERCENT` subtype listing
        if (match.params.offerListSubType === OfferListSubType.CREDIT_TWO_PERCENT) {
            return;
        }

        const route = {
            pathname: location.pathname,
            query: parseSearch(location.search),
            url: location.pathname + location.search + location.hash,
            hash: location.hash
        };
        const ctx = {
            route,
            prevRoute: null,
            prevResult: {},
            meta: clientRpRequestMeta,
            match
        };

        await dispatch(fetchOfferList(ctx, latestQuery));
    };
};
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useRouteMatch} from "react-router";

import {parseSearch} from "@pg-mono/request";

import {clientRpRequestMeta} from "../../../../client/client_rp_request_meta";
import {IRPStore} from "../../../app/rp_reducer";
import {fetchOfferList} from "../actions/fetch_offer_list";
import {OfferListSubType} from "../types/OfferListSubType";

export const useFetchOfferList = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const match = useRouteMatch<{friendlySlug?: string; offerListSubType?: OfferListSubType}>();
    const latestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);

    return async () => {
        // Do not fetch offers for `CREDIT_TWO_PERCENT` subtype listing
        if (match.params.offerListSubType === OfferListSubType.CREDIT_TWO_PERCENT) {
            return;
        }

        const route = {
            pathname: location.pathname,
            query: parseSearch(location.search),
            url: location.pathname + location.search + location.hash,
            hash: location.hash
        };
        const ctx = {
            route,
            prevRoute: null,
            prevResult: {},
            meta: clientRpRequestMeta,
            match
        };

        await dispatch(fetchOfferList(ctx, latestQuery));
    };
};
